import { observable, action, computed, configure, runInAction } from 'mobx';
import { createContext } from 'react';
import { ITechnicianCertificate } from '../models/techniciancertificate';
import { ICertificate } from '../models/certificate';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { ITransmission } from '../models/transmission';
import { ITransmissionChecklist } from '../models/transmissionchecklist';

configure({enforceActions: 'always'});

class TechnicianTransmissionStore {
  @observable techniciantransmissionRegistry = new Map();
  @observable technicianRegistry = new Map();
  @observable techniciantransmission: ITransmission | null = null;
  @observable certificateRegistry = new Map();
  @observable photouploadCount = new Map();
  @observable certificate: ICertificate | null = null;
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable uploadingFile = false;
  @observable ifSubmitted = false;
  @observable target = '';

  @computed get techniciantransmissionsByDate() {
    return Array.from(this.techniciantransmissionRegistry.values()).sort(
      (a, b) => Date.parse(a.estimatedCompletionDate) - Date.parse(b.estimatedCompletionDate))
    ;
  }

  @action loadTechnicianTransmissions = async () => {
    this.loadingInitial = true;
    try {
      const techniciantransmissions = await agent.TechnicianTransmissions.list();
      runInAction('loading techniciancertificates', () => {
        this.techniciantransmissionRegistry.clear();
        techniciantransmissions.forEach(techniciantransmission => {         
          this.techniciantransmissionRegistry.set(techniciantransmission.id, techniciantransmission);
        });
        this.loadingInitial = false;
      })

    } catch (error) {
      runInAction('load TechnicianCertificate List error', () => {
        this.loadingInitial = false;
      })
      toast.error('load TechnicianCertificate List error');
    }
  };

  @action loadTechnicianTransmission = async (id: string) => {
    let techniciantransmission = this.getTechnicianTransmission(id);
    if (techniciantransmission) {
      this.techniciantransmission = techniciantransmission;
      return techniciantransmission;
    } else {
      this.loadingInitial = true;
      try {
        techniciantransmission = await agent.Transmissions.details(id);

        runInAction("getting technician", () => {
          this.techniciantransmission = techniciantransmission;
          this.loadingInitial = false;
        });
        return techniciantransmission;
      } catch (error) {
        runInAction("get technician error", () => {
          this.loadingInitial = false;
        });
        toast.error("get technician error");
        console.log(error);
      }
    }
  };

  @action clearTechnicianTransmission = () => {
    this.techniciantransmission = null;
  }

  getTechnicianTransmission = (id: string) => {
    return this.techniciantransmissionRegistry.get(Number(id));
  }

  @action createTransmissionChecklist = async (transmissionchecklist: ITransmissionChecklist) => {
    this.submitting = true;
    try {
      await agent.TechnicianTransmissions.create(transmissionchecklist);
      runInAction('create Transmission Checklist', () => {
        this.submitting = false;
        this.ifSubmitted = true;
      });
      toast.success('create Transmission Checklist successfully');
    } catch (error) {
      runInAction('create Transmission Checklist error', () => {
        this.submitting = false;
      })
      toast.error('create Transmission Checklist error');
      console.log(error);
    }
  };

//   @action editTechnicianTransmission = async (techniciantransmission: ITechnicianCertificate) => {
//     this.submitting = true;
//     try {
//       await agent.TechnicianTransmissions.update(techniciantransmission);
//       runInAction('editing techniciantransmission', () => {
//         this.techniciantransmissionRegistry.set(techniciantransmission.id, techniciantransmission);
//         this.techniciantransmission = techniciantransmission;
//         this.submitting = false;
//       })
//     } catch (error) {
//       runInAction('edit techniciantransmission error', () => {
//         this.submitting = false;
//       })
//       toast.error('edit techniciantransmission error');
//       console.log(error);
//     }
//   };

//   @action deleteTechnicianTransmission = async (id: string) => {
//     this.submitting = true;
//     this.target = id;
//     try {
//       await agent.TechnicianCertificates.delete(id);
//       runInAction('deleting TechnicianCertificate', () => {
//         this.techniciantransmissionRegistry.delete(id);
//         this.submitting = false;
//         this.target = '';
//       })
//     } catch (error) {
//       runInAction('delete TechnicianCertificate error', () => {
//         this.submitting = false;
//         this.target = '';
//       })
//       toast.error('delete TechnicianCertificate error');
//       console.log(error);
//     }
//   }

// @action loadCertificates = async () => {
//   this.loadingInitial = true;
//   try {
//     const certificates = await agent.Certificates.list();
//     runInAction('loading certificates', () => {
//       certificates.forEach(certificate => {
//         this.certificateRegistry.set(certificate.id, certificate);
//       });
//       this.loadingInitial = false;
//     })

//   } catch (error) {
//     runInAction('load Certificate List error', () => {
//       this.loadingInitial = false;
//     })
//     toast.error('load Certificate List error');
//   }
// };

@action uploadTransmissionPhoto = async (photo : File[], id : string, siteId : string, category : string) => {
  if (typeof photo !== 'undefined' && photo.length > 0) 
  {  
    this.uploadingFile = true;   
  try {
    // var photos : File[] = [];
    // photos.push(photo);
    const photoreturn = await agent.TechnicianTransmissions.uploadTransmissionPhoto(photo, id, siteId, category);
    runInAction(() => {
    this.photouploadCount.set(id, photoreturn.count);
     this.uploadingFile = false;
     toast.success('Photo uploaded successfully!');
    });
  } catch (error) {
    console.log(error);
    toast.error('Problem uploading photo');
    runInAction(() => {
      this.uploadingFile = false;
    });
  }
}
};

@action loadTechnicians = async () => {
  this.loadingInitial = true;
  try {
    const technicians = await agent.Employees.list();
    runInAction("loading technicians", () => {
      this.technicianRegistry.clear();
      technicians.forEach((technician) => {
        if (technician.department === "Technician" && technician.status !== 'Resigned' && 
        technician.projectType.includes('Transmission')) 
          {
            this.technicianRegistry.set(technician.email, technician);
          }
      });
      this.loadingInitial = false;
    });
  } catch (error) {
    runInAction("load Technician List error", () => {
      this.loadingInitial = false;
    });
    toast.error("load Technician List error");
  }
};

}

export default createContext(new TechnicianTransmissionStore());
